module.exports = __webpack_public_path__ + "static/media/monkey.402e707f.png";